import { Button, Tag, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useT } from "../i18n/context";
import type { TodoItem } from "../types";

const { Text } = Typography;

interface TodoPanelProps {
  todos: TodoItem[];
  open: boolean;
  onClose: () => void;
}

export default function TodoPanel({ todos, open, onClose }: TodoPanelProps) {
  const t = useT();
  if (!open || todos.length === 0) return null;

  const done = todos.filter((td) => td.status === "completed").length;

  return (
    <div
      style={{
        position: "absolute",
        top: 48,
        right: 20,
        zIndex: 1000,
        background: "var(--lude-im-bg-elevated)",
        border: "1px solid var(--lude-im-border)",
        borderRadius: "var(--lude-im-radius-card)",
        padding: 12,
        width: 320,
        maxHeight: 400,
        overflow: "auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <Text strong style={{ fontSize: 13 }}>
          {t("todo.title")} ({done}/{todos.length})
        </Text>
        <Button type="text" size="small" onClick={onClose}>
          <CloseOutlined style={{ fontSize: 10 }} />
        </Button>
      </div>
      {todos.map((td) => (
        <div
          key={td.id}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
            padding: "6px 0",
            borderBottom: "1px solid var(--lude-im-border)",
            opacity: td.status === "completed" ? 0.6 : 1,
          }}
        >
          <span style={{ fontSize: 14, flexShrink: 0, marginTop: 1 }}>
            {td.status === "completed" ? "✅" : td.status === "in_progress" ? "🔄" : "⬜"}
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Text
              style={{
                fontSize: 12,
                textDecoration: td.status === "completed" ? "line-through" : "none",
                wordBreak: "break-word",
              }}
            >
              {td.content}
            </Text>
            {td.priority && (
              <Tag
                color={
                  td.priority === "high"
                    ? "red"
                    : td.priority === "medium"
                    ? "orange"
                    : "default"
                }
                style={{ fontSize: 10, marginLeft: 4, lineHeight: "16px" }}
              >
                {td.priority}
              </Tag>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
